import { render, staticRenderFns } from "./huovHandling.vue?vue&type=template&id=879d00be"
import script from "./huovHandling.vue?vue&type=script&lang=js"
export * from "./huovHandling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports